<script lang="ts">
  import type {
    CategorySource,
    CategoryWithSources,
    Source,
  } from '../../modules/source/source.interface';
  import { Button, Dialog } from 'svelte-materialify';
  import { onMount } from 'svelte';
  import { ProjectConfigService, SourceService } from '../../modules';
  import SourceEdit from '../source/SourceEdit.svelte';
  import SourceList from '../source/SourceList.svelte';
  import { wrapProgress } from '../../store';
  import Page from '../Page.svelte';

  export let params: { project: string };

  const projectConfig = ProjectConfigService.get(params.project);
  let editDialogActive = false;
  let isEdit = false;
  let categoriesWithSources: CategoryWithSources[];
  let source: Source;

  onMount(fetchSourceCounts);

  function fetchSourceCounts() {
    return wrapProgress(async () => {
      categoriesWithSources = await SourceService.getCategoriesWithSources(
        params.project
      );
    })();
  }

  function createNewSource() {
    isEdit = false;
    toggleDialog();
  }

  function toggleDialog() {
    editDialogActive = !editDialogActive;
  }

  async function onSourceCreate(evt: { detail: Source }) {
    const source = evt.detail;

    await SourceService.create(source);
    toggleDialog();
    fetchSourceCounts();
  }

  async function onSourceUpdate(evt: { detail: Source }) {
    const source = evt.detail;

    await SourceService.update(source);
    toggleDialog();
    fetchSourceCounts();
  }

  async function onSourceClick(evt: { detail: CategorySource }) {
    const { id } = evt.detail;

    source = await SourceService.get(id);
    isEdit = true;
    toggleDialog();
  }

  async function onSourceDelete(evt: { detail: CategorySource }) {
    const { id } = evt.detail;

    await SourceService.delete(id);
    toggleDialog();
    fetchSourceCounts();
  }
</script>

<Page title="Sources">
  <div slot="actions">
    <Button class="green white-text" on:click={() => createNewSource()}>Create New</Button
    >
  </div>
  {#if categoriesWithSources}
    <SourceList {categoriesWithSources} on:source-click={wrapProgress(onSourceClick)} />
  {/if}
</Page>

<Dialog class="full-height" width={1280} bind:active={editDialogActive}>
  {#if editDialogActive}
    <SourceEdit
      {projectConfig}
      {source}
      {isEdit}
      on:create={wrapProgress(onSourceCreate)}
      on:update={wrapProgress(onSourceUpdate)}
      on:delete={wrapProgress(onSourceDelete)}
    />
  {/if}
</Dialog>
